import styles from './Link.module.css';

export const Link = ({
    href,
    children,
    className = '',
    target = '_self',
    rel = 'noopener noreferrer',
}: {
    href: string;
    children: React.ReactNode;
    className?: string;
    target?: string;
    rel?: string;
}) => {
    return (
        <a
            href={href}
            className={[styles.container, className].join(' ')}
            target={target}
            rel={rel}
        >
            {children}
        </a>
    );
}